module.exports = __webpack_public_path__ + "static/media/Class.610cc7cb.jpg";